module.exports = __webpack_public_path__ + "img/left-arrow.b01fef23.svg";